export default __webpack_public_path__ + "static/media/arrow_back_ios_new.9fdf99b3.svg";